<template>
    <div class="kgk-account-activate">
        <h1>Accountaktivierung</h1>
        <div class="spacer"></div>
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import router from '../router';

    import registration from './../api/registration';

    export default {
        name: 'Activate',
        props: {
            code: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                loading: false,
                error: '',
            }
        },
        components: {

        },
        watch: {
            code: {
                immediate: true,
                handler(code) {
                    if( !code || code.length == 0 ) {
                        return;
                    }

                    if( this.loading ) {
                        return;
                    }

                    this.loading = true;

                    registration.activate(
                        this,
                        code,
                        () => {
                            this.$notify({
                                type: 'success',
                                title: 'Account aktiviert',
                                text: 'Dein Account wurde erfolgreich aktiviert. Bitte melde dich nun an.'
                            });

                            router.push('/login');
                        },
                        e => {
                            this.loading = false;

                            if( e.response.status == 404 ) {
                                this.error = e.response.data.message || 'Der Aktivierungscode ist nicht oder nicht mehr gültig.';

                                this.$notify({
                                    type: 'error',
                                    title: 'Aktivierungsfehler',
                                    text: this.error
                                });

                                return;
                            }

                            this.error = e.response.data.message || 'Es ist ein unbekannter Fehler aufgetreten.';

                            this.$notify({
                                type: 'error',
                                title: 'Aktivierungsfehler',
                                text: this.error
                            });
                        },
                        () => {}
                    );
                }
            }
        },
        mounted() {

        }
    }
</script>
